import * as App from "@timesheets/routes-app";

import { PageTypes, commonRoutes } from "@/routing";

import { IApi } from "@timesheets/webapp-support";
import { RouteConfig } from "vue-router";
import { clients } from "./clients";
import { contacts } from "./contacts";
import { contractors } from "./contractors";
import { contracts } from "./contracts";
import { reminders } from "./reminders";
import { roles } from "./roles";
import { settings } from "./settings";
import { timesheets } from "./timesheets";

export function routes(api: IApi) {
  const routes = commonRoutes(api, PageTypes.Dashboard).concat([
    {
      path: App.Home,
      name: "Home",
      component: async () => import(/* webpackChunkName: "roles" */ "Dashboard/components/Roles/RolesList/Index.vue"),
    },
    ...contacts,
    ...contracts,
    ...contractors,
    ...clients,
    ...roles,
    ...reminders,
    ...settings,
    ...timesheets,
  ]);

  addMeta(routes);

  return routes;
}

function addMeta(routes: RouteConfig[]) {
  routes.forEach(route => {
    if (route.meta) {
      route.meta.group = PageTypes.Dashboard;
    } else {
      route.meta = {
        group: PageTypes.Dashboard,
      };
    }
  });
}
